<template>
	<button 
		v-if="type === 'text'"
		class="btn btn-text"
		:class="[colors, hoverColors, padding]"
		:style="{
			width: buttonWidth
		}"
		@click="onClick"
	>{{ label }}</button>
	<button
		v-else-if="type === 'icon'"
		class="btn btn-icon"
		:class="[colors, hoverColors, padding]"
		@click="onClick"
	>
		<UiIcon
			:name="name"
			:size="iconSize"
		/>
	</button>
</template>

<script>
import UiIcon from '@/components/ui/Icon'

export default {
	name: 'UiButtons',
	components: {
		UiIcon
	},
	props: {
		label: {
			type: String,
			default: 'Button'
		},
		type: {
			type: String,
			default: 'text'
		},
		name: {
			type: String,
			default: ''
		},
		width: {
			type: [String, Number],
			default: 150
		},
		iconSize: {
			type: Number,
			default: 24
		},
		theme: {
			type: String,
			default: 'primary'
		},
		hover: {
			type: Boolean,
			default: true
		},
		onClick: {
			type: Function,
			default: () => {}
		}
	},
	computed: {
		colors() {
			return this.theme === 'transparent'
				? 'bg-transparent text-inherit'
				: this.theme === 'secondary'
				? 'bg-black text-white'
				: 'bg-red text-white'
		},
		hoverColors() {
			return this.hover && this.theme !== 'transparent'
				? this.theme === 'secondary'
					? 'hover:bg-red'
					: 'hover:bg-black'
				: ''
		},
		buttonWidth() {
			return this.width === 'auto'
				? this.width
				: this.width + 'px'
		},
		padding() {
			return this.theme === 'transparent'
				? ''
				: 'p-2'
		}
	}
}
</script>

<style scoped>
.btn {
	display: flex !important;
	flex-flow: row nowrap !important;
	justify-content: center !important;
	align-items: center !important;
	text-align: center !important;
}
</style>